import { useAppDispatch } from '../../../../store';

export const useAdminConversationUsersSearchForm = () => {
    const dispatch = useAppDispatch();
    return {};
};
